var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViviendassecundaria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10V6.11749C9.99938 6.07472 9.99124 6.03252 9.976 5.99338C9.9608 5.95423 9.9388 5.91892 9.91135 5.88958L7.18407 3.08103C7.13382 3.02891 7.06815 3 7 3C6.93185 3 6.86618 3.02891 6.81589 3.08103L4.08864 5.88958C4.06119 5.91892 4.03921 5.95423 4.02399 5.99338C4.00877 6.03252 4.00061 6.07472 4 6.11749V10",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H11",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6758 19.7158V13.2177C18.6747 13.1461 18.6606 13.0755 18.6341 13.01C18.6078 12.9445 18.5696 12.8854 18.5219 12.8363L13.7882 8.13562C13.701 8.04838 13.587 8 13.4688 8C13.3505 8 13.2365 8.04838 13.1492 8.13562L8.41556 12.8363C8.36793 12.8854 8.32978 12.9445 8.30336 13.01C8.27694 13.0755 8.26278 13.1461 8.26172 13.2177V19.7158",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95703 19.7144H20.113",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7637 19.7151V16.298C14.7637 16.1685 14.718 16.0443 14.6366 15.9528C14.5552 15.8612 14.4448 15.8098 14.3298 15.8098H12.5941C12.479 15.8098 12.3686 15.8612 12.2872 15.9528C12.2059 16.0443 12.1602 16.1685 12.1602 16.298V19.7151",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViviendassecundaria);
export default __webpack_public_path__ + "static/media/Viviendas secundaria.e4f6c94f26546c9ef6786265ad7940a0.svg";
export { ForwardRef as ReactComponent };